import Contador from '../assets/contador.jfif'
import TodoReact from '../assets/example-three.jpeg'

import TodoVanilla from '../assets/todolist.jfif'
import Milhao from '../assets/milhao.jpeg'
import Port from '../assets/portf.jpeg'

export const ProjectList = [
    {
        name: "Roda a Roda do milhão ",
        image: Milhao,
        description: "Jogo inspirado nos jogo Roda a Roda do SBT |  Você já começa com 50 reais e, se perder no primeiro turno, você leva pra casa os 50, mas se deseja participar de novo, você inicia com 0."
    },

    {
        name: "Todo-List | React",
        image: TodoReact,
        description: "Diria que este Todo foi um Upgrade, adaptado e redesenhado para Todo e atender minhas necessidades de estudo. Existem duas versões dele, um usando Json-server para fazer a requisições e outro usando o local storage"
    },

    {
        name: "Todo-List | HTML, CSS e JS Vanilla",
        image: TodoVanilla,
        description: "Como o título sugere, ele foi feito com estas tecnologias. Foi o primeiro projeto todo que fiz. Muito bom para treinar operações de CRUD"
    },


    {
        name: "Portfólio | Primeira versão",
        image: Port,
        description: "No primeiro contato que tive com HTML, CSS e Js, criei a primeira versão do meu portfólio."
    },

    {
        name: "DecolaTech Counter",
        image: Contador,
        description: "Desafio proposto no bootCamp da dio Avanade-DecolaTech, onde o contador não conta números negativos e só até 10."
    },

  
]
